var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyImpairment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 253,
    viewBox: "0 0 257 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6875 73.6841H154.688V87.6841H92.6875V73.6841Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.687 73.6841H190.687V87.6841H176.687V73.6841Z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6875 109.684H154.688V123.684H92.6875V109.684Z",
    fill: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.687 109.684H190.687V123.684H176.687V109.684Z",
    fill: "#B3B3B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.156 0L256.668 10.7008L10.5117 252.505L6.85344e-05 241.804L246.156 0Z",
    fill: "#B3B3B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.798 27.8672L195.687 15.7554L177.687 33.7554L159.687 15.7554L141.687 33.7554L123.687 15.7554L105.687 33.7554L87.6865 15.7554L69.6865 33.7554L56.6865 20.7554V176.307L70.6865 162.555V39.6843H195.769L207.798 27.8672ZM70.6865 172.367L46.9498 195.684H68.3548L82.6067 181.684H70.6865V172.367ZM212.687 53.9043V39.6843H205.757L212.748 32.8171L213.687 33.7554L226.687 20.7554V40.1518L212.687 53.9043ZM92.5957 181.684H178.687V212.684C178.687 222.046 186.325 229.684 195.687 229.684C205.048 229.684 212.687 222.046 212.687 212.684V63.7167L226.687 49.9642V212.684C226.687 229.843 212.845 243.684 195.687 243.684H51.6865C45.3863 243.684 39.5333 241.818 34.6485 238.607L45.0913 228.349C47.1211 229.208 49.3501 229.684 51.6865 229.684H164.687V195.684H78.3437L92.5957 181.684ZM39.2603 224.264C36.4253 221.225 34.6865 217.151 34.6865 212.684V207.731L21.6771 220.51C23.0192 225.696 25.6651 230.349 29.2464 234.101L39.2603 224.264ZM20.6865 211.671L34.6865 197.918V195.684H36.9608L51.2128 181.684H20.6865V211.671Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImpairment);
export default __webpack_public_path__ + "static/media/empty_impairment.0d2a23106236ae47b72358b15ef16d93.svg";
export { ForwardRef as ReactComponent };